<script setup lang="ts">
import merge from 'lodash-es/merge';

interface FormSettings
{
    settings: any;
}

defineOptions({
    name: 'WidgetEmployeesSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    employees: '12'
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const displayOptions = computed((): Option[] =>
{
    return [
        { value: '4', text: $t('[[[4]]]') },
        { value: '8', text: $t('[[[8]]]') },
        { value: '12', text: $t('[[[12]]]') },
        { value: '16', text: $t('[[[16]]]') },
        { value: '20', text: $t('[[[20]]]') },
        { value: '24', text: $t('[[[24]]]') }
    ];
});

async function validate(): Promise<void>
{
}

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Liczba wyświetlanych nowych pracowników]]]')" :invalid-feedback="form.$errors.first('settings.employees')" :state="form.$errors.state('settings.employees')">
        <IdeoFormSelect v-model="form.settings.employees" :options="displayOptions" />
    </IdeoFormGroup>
</template>
